// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"cfe5e1be","144":"9c381494","219":"d8a612e6","364":"fa90ca38","453":"9ccf3f97","543":"7f475207","573":"bb048408","588":"aec150cd","616":"35fe059e","634":"90219d86","709":"42126f48","888":"85cb7193"}[chunkId] + ".chunk.js";
};